import request from '@utils/request'
import { Config, ReturnType } from './types'

const getAll = async (action: any, state: string, params: any) => {
  try {
    const config: ReturnType = {
      url: `orders`,
      method: 'get',
      params,
      authorization: true,
      config: {
        showErr: true,
        store: {
          action: action,
          key: state,
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}

const pickupDriver = async (data: any, orderId: any) => {
  try {
    const config: ReturnType = {
      url: `orders/pick-up-driver/${orderId}`,
      method: 'patch',
      data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Pickup Driver Assigned successfully!',
        store: {
          action: 'update',
          key: 'orders',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const returnDriver = async (data: any, orderId: any) => {
  try {
    const config: ReturnType = {
      url: `orders/return-driver/${orderId}`,
      method: 'patch',
      data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Return Driver Assign successfully!',
        store: {
          action: 'update',
          key: 'orders',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const getAllBookLent = async (
  action: Config['store']['action'],
  params: any,
) => {
  try {
    const config: ReturnType = {
      url: `orders`,
      method: 'get',
      params,
      authorization: true,
      config: {
        showErr: true,
        store: {
          action: action,
          key: 'userBookLent',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const getAllBookBorrow = async (
  action: Config['store']['action'],
  params: any,
) => {
  try {
    const config: ReturnType = {
      url: `orders`,
      method: 'get',
      params,
      authorization: true,
      config: {
        showErr: true,
        store: {
          action: action,
          key: 'userBookBorrow',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const create = async (data: any) => {
  try {
    const config: ReturnType = {
      url: 'orders',
      method: 'post',
      data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Order created successfully!',
        store: {
          action: 'prepend',
          key: 'orders',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const update = async (data: any, id: number) => {
  try {
    const config: ReturnType = {
      url: `orders/${id}`,
      method: 'patch',
      data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Order created successfully!',
        store: {
          action: 'update',
          key: 'orders',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const updateStatus = async (state: string, data: any, id: number) => {
  try {
    const config: ReturnType = {
      url: `orders/update-status/${id}`,
      method: 'patch',
      data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Order Status updated successfully!',
        store: {
          action: 'update',
          key: state,
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const adminAssignPickupDriver = async (data: any, id: number) => {
  try {
    const config: ReturnType = {
      url: `orders/pick-up-driver/${id}`,
      method: 'patch',
      data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Pickup driver assigned successfully!',
        store: {
          action: 'update',
          key: 'orders',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const adminAssignReturnDriver = async (data: any, id: number) => {
  try {
    const config: ReturnType = {
      url: `orders/return-driver/${id}`,
      method: 'patch',
      data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Return driver assigned successfully!',
        store: {
          action: 'update',
          key: 'orders',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const remove = async (id: any) => {
  try {
    const config: ReturnType = {
      url: `orders/${id}`,
      method: 'delete',
      authorization: true,

      config: {
        showErr: true,
        successMsg: 'Order deleted successfully!',
        store: {
          action: 'remove',
          key: 'orders',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}

export default {
  remove,
  update,
  create,
  getAll,
  updateStatus,
  adminAssignPickupDriver,
  adminAssignReturnDriver,
  getAllBookLent,
  getAllBookBorrow,
  pickupDriver,
  returnDriver,
}
